import type { PipelineCardDetail } from '@/pages/pipelines/common/types';

type PipelineDetailAction = PipelineCardDetail['headerActions'][number];

const actionHasPlacement = (
  action: PipelineDetailAction,
  placement: NonNullable<PipelineDetailAction['placement']>,
) => action.placement === placement;

const actionIsUnplaced = (action: PipelineDetailAction) => !action.placement;

const actionMatches = (action: PipelineDetailAction, matches: string[]) => {
  const key = action.key.toLowerCase();
  const label = action.label.toLowerCase();

  return matches.some((match) => key.includes(match) || label.includes(match));
};

const isPipelineMessageAction = (action: PipelineDetailAction) =>
  actionMatches(action, ['message']);

const isPipelineProfileAction = (action: PipelineDetailAction) =>
  actionMatches(action, ['profile']) ||
  (actionMatches(action, ['investor']) && !isPipelineMessageAction(action));

export const getPipelineDetailActions = (detail: PipelineCardDetail): PipelineDetailAction[] =>
  detail.headerActions.filter((action) => action.href || action.disabled);

export const getPipelineDetailHeaderAction = (actions: PipelineDetailAction[]) =>
  actions.find((action) => actionHasPlacement(action, 'header'));

export const getPipelineDetailInlineMetaAction = (actions: PipelineDetailAction[]) =>
  actions.find((action) => actionHasPlacement(action, 'inlineMeta')) ??
  actions.find(isPipelineProfileAction);

export const getPipelineDetailPrimaryAction = (actions: PipelineDetailAction[]) =>
  actions.find((action) => actionHasPlacement(action, 'primary')) ??
  actions.find((action) => actionIsUnplaced(action) && isPipelineMessageAction(action)) ??
  actions.find((action) => actionIsUnplaced(action) && !isPipelineProfileAction(action));
